import type { SelfEmployedPayoutMethod } from '@/shared/api'

export const accountLinkValidator = {
    bank_id: {
        validate: (value: SelfEmployedPayoutMethod['bank_id']) =>
            value ? true : 'Банк является обязательным полем',
    },
    email: {
        required: 'Электронная почта является обязательным полем',
        pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: 'Напишите в формате abc@mail.ru',
        },
    },
    phone: {
        required: 'Телефон является обязательным полем',
        pattern: {
            value: /^[0-9]{11}$/,
            message: 'Введите номер в формате +7 (ххх) ххх хх хх',
        },
    },
}
